import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalUserProfile from '../../../../../stores/global-user-profile';

export interface FeedbackAnswer {
  questionId: number;
  selectedOptionId?: number | null;
  textResponse?: string | null;
}

export const submitFeedbackAnswersOperation = async (
  programId: number,
  courseId: number,
  feedbackId: number,
  answers: FeedbackAnswer[],
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    if (answers.length === 0) {
      toast.warn('יש לענות על לפחות שאלה אחת');
      return;
    }

    setLoading(true);
    await appApi.submitCourseFeedbackAnswers(
      programId,
      courseId,
      feedbackId,
      answers,
    );

    // Refresh user profile to get updated polls list
    await globalUserProfile.getUserProfile();

    toast.success('המשוב נשלח בהצלחה, תודה על שיתוף הפעולה!');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('לא ניתן לשלוח את המשוב, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
